import { CMSPersonProps } from "@types";

export const formatPersonName = (person: CMSPersonProps): string => {
    const prefix = person.prefix ? `${person.prefix}. ` : "";

    if (person.first_name && person.last_name) return `${prefix}${person.first_name} ${person.last_name}`;

    if (person.first_name) return `${prefix}${person.first_name}`;

    if (person.last_name) return `${prefix}${person.last_name}`;

    return `${prefix}${person?.title ? person.title : ""}`;
};

export const getInitials = (person: CMSPersonProps): string => {
    if (person.first_name && person.last_name) return `${person.first_name.charAt(0)} ${person.last_name.charAt(0)}`;

    if (person.first_name) return `${person.first_name.charAt(0)}`;

    if (person.last_name) return `${person.last_name.charAt(0)}`;

    return `${person?.title ? person.title.charAt(0) : ""}`;
};
